<template>
  <div class="container">
    <a-scene
      id="scene"
      :background="backgroundcolor"
      :fog="fog"
      renderer="colorManagement:true;"
      render-enabled
      embedded
      vr-mode-ui="enabled: false"
      keyboard-shortcuts="enterVR:false;"
      shadow="type: basic"
      physics="friction: 0.02;
			restitution:0;
			contactEquationStiffness:1e8;
			contactEquationRelaxation:3;
			iterations:10;"
    >
      <a-entity :light="ambient"/>
      <a-entity
        id="light_scene"
        light="
					type:directional;
					color:#BBB; 
					intensity:0.5; 
					castShadow:true;
					shadowCameraLeft:-10;
					shadowCameraRight:7;
					shadowCameraTop:6;
					shadowCameraBottom:-2;
					shadowMapHeight:1024;
					shadowMapWidth:1024;
					shadowCameraFar:14;
					shadowCameraNear:1;
				"
        position="-2 4 4"
      />
      <a-entity
        id="camera"
        camera="fov:50;"
        orbit-controls="target: 0 0.3 -3.5; minDistance: 0.5; maxDistance: 180; initialPosition: 0 1.6 3; enableZoom:false;enablePan:false;maxPolarAngle:89;minPolarAngle:10;dampingFactor:0.1;"
      >
        <a-entity cursor="rayOrigin: mouse;" raycaster="objects: .clickable; near: 0.1; far:50;"/>
      </a-entity>
      <a-entity
        :gltf-model="sofa"
        custommaterial
        class="clickable"
        position="0 7 -3.5"
        scale="0.04 0.04 0.04"
        shadow
        animation__drop="property:position; to: 0 0.76 -3.5;dur:2000; autoplay:true; easing:easeOutSine;"
        data-startpos="0 7 -3.5"
        data-zlock="-3.5"
        @animationcomplete="becomeMovable"
      />
      <a-entity
        :gltf-model="vases"
        :envmap="envmap"
        class="clickable"
        position="3 7 -3"
        scale="0.002 0.002 0.002"
        shadow
        mass="1"
        animation__drop="property:position; to: 3 0.95 -3;dur:3000;delay:1000; autoplay:true; easing:easeOutSine;"
        data-startpos="3 7 -3"
        data-zlock="-3"
        @animationcomplete="becomeMovable"
      />
      <a-entity
        class="clickable"
        geometry="primitive: cylinder; radius:0.64;height:0.88;"
        material="transparent:true;opacity:0;renderOrder:0;"
        position="3 5 -3"
        movable="startPos:3 5 -3;collision:auto;"
        data-startpos="3 5 -3"
        data-zlock="-3"
        @animationcomplete="becomeMovable"
      >
        <a-entity :gltf-model="table" position="0 -0.44 0" scale="0.002 0.002 0.002" shadow/>
      </a-entity>
      <a-entity
        id="lamp"
        class="clickable"
        geometry="primitive: cylinder; radius:0.24;height:2.4;"
        material="transparent:true;opacity:0;renderOrder:0;"
        position="-2.5 5 -3"
        data-zlock="-3"
        movable="startPos:-2.5 5 -3;collision:auto;"
      >
        <a-entity
          :gltf-model="lamp"
          :envmap="envmap"
          class="clickable"
          rotation="0 45 0"
          position="0 -1.2 0"
          scale="0.002 0.002 0.002"
          shadow
        >
          <a-entity
            id="light_lamp"
            light="
							type:spot;
							color:#BBB; 
							intensity:6;
							penumbra:1;
							distance:3;
							castShadow:true;
							shadowCameraLeft:-10;
							shadowCameraRight:7;
							shadowCameraTop:6;
							shadowCameraBottom:-2;
							shadowMapHeight:1024;
							shadowMapWidth:1024;
							shadowCameraFar:14;
							shadowCameraNear:0.1;
						"
            rotation="-90 0 0"
            position="0 1076 441"
          />
          <a-entity
            light="
							type:point;
							color:#BBB; 
							intensity:5;
							decay:1;
							distance:0.5;
						"
            rotation="-90 0 0"
            position="0 1076 441"
          />
        </a-entity>
      </a-entity>
      <a-entity
        :gltf-model="rug"
        position="0 0 10"
        rotation="0 90 0"
        scale="0.0015 0.0015 0.0015"
        animation__move="property:position; to: -0 0.033 -3.5;dur:2000; autoplay:true; easing:easeOutSine;"
        shadow
      />
      <a-entity
        :material="floor"
        geometry="primitive:cylinder;radius:20;height:0.1;"
        position="0 0 -3.5"
        shadow
      />
      <a-entity
        static-body
        position="0 -0.01 -3.5"
        geometry="primitive:cylinder;radius:9;height:0.1;"
      />
    </a-scene>
  </div>
</template>
<script>
if (process.browser) {
  if (!window.AFRAME) {
    require("aframe");
  }
  if (!AFRAME.components["dynamic-body"]) {
    require("aframe-physics-system");
  }
  if (!AFRAME.components["orbit-controls"]) {
    require("aframe-orbit-controls");
  }
  require("../../plugins/movable.js");
  require("../../plugins/intersect-plane.js");
  require("../../plugins/envmap.js");
  require("../../plugins/aframedestroy.js");
  require("../../plugins/custommaterial.js");
}

export default {
  props: {
    backgroundColour: {
      type: String,
      default: "#3cb2ac",
      required: false
    },
    assetRoot: {
      type: String,
      default: "https://lab.pikcells.com/assets/",
      required: false
    }
  },
  computed: {
    table: function() {
      return this.assetRoot + "models/table/PBR - Metallic Roughness.gltf";
    },
    rug: function() {
      return this.assetRoot + "models/rug/Heals_Linie_Rug.gltf";
    },
    lamp: function() {
      return this.assetRoot + "models/lamp/PBR - Metallic Roughness.gltf";
    },
    envmap: function() {
      return "src:" + this.assetRoot + "cubes/kitchen;intensity:1;";
    },
    vases: function() {
      return this.assetRoot + "models/vases/Amalfi_Vases.gltf";
    },
    sofa: function() {
      return this.assetRoot + "models/sofa/AURORA-2-SEATER.gltf";
    },
    fog: function() {
      return "type: linear; near:10; far:15; color: " + this.backgroundColour;
    },
    backgroundcolor: function() {
      return "color:" + this.backgroundColour;
    },
    floor: function() {
      return (
        "src:https://lab.pikcells.com/assets/textures/architecture-floor.jpg; repeat: 30 30; color: " +
        this.backgroundColour
      );
    },
    ambient: function() {
      return "type:ambient; intensity:0.5; color: #fff";
    }
  },
  destroyed: function(event) {
    AFRAME.destory();
  },
  methods: {
    becomeMovable: function(event) {
      var collisiontype = event.target.getAttribute("collision");
      if (collisiontype === null) {
        collisiontype = "auto";
      }
      var mass = event.target.getAttribute("mass");
      if (mass === null) {
        mass = "5";
      }
      event.target.setAttribute(
        "movable",
        "startPos:" +
          event.target.getAttribute("data-startpos") +
          ";collision:" +
          collisiontype +
          ";mass:" +
          mass +
          ";"
      );
    }
  }
};
</script>
<style>
a-scene {
  width: 100%;
  height: 100%;
}
.container {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.turn-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-bottom: 10px;
}
</style>
